"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _lodash = _interopRequireDefault(require("lodash"));

var _basic_provider = _interopRequireDefault(require("./_basic_provider"));

var HitlSettingsApi =
/*#__PURE__*/
function (_BasicProviderApi) {
  (0, _inherits2.default)(HitlSettingsApi, _BasicProviderApi);

  /**
   * Represents a Hitl Settings Api.
   * @constructor
   */
  function HitlSettingsApi(_ref) {
    var userTokenFactory = _ref.userTokenFactory,
        sdkApiUrl = _ref.sdkApiUrl,
        providersAccountId = _ref.providersAccountId,
        httpGatewayUrl = _ref.httpGatewayUrl,
        sendWSMessage = _ref.sendWSMessage;
    (0, _classCallCheck2.default)(this, HitlSettingsApi);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(HitlSettingsApi).call(this, {
      userTokenFactory: userTokenFactory,
      sdkApiUrl: sdkApiUrl,
      providersAccountId: providersAccountId,
      httpGatewayUrl: httpGatewayUrl,
      sendWSMessage: sendWSMessage
    }));
  }
  /**
   *
   * @param {Array} param0.categories categories of canned message
   * @param {Boolean} param1.isCommon is common canned message
   * @param {Boolean} param2.ignoreRuleTags ignore rule tags in logic of canned msgs list
   * @returns {Array} canned messages list
   */


  (0, _createClass2.default)(HitlSettingsApi, [{
    key: "getCannedMessagesList",
    value: function () {
      var _getCannedMessagesList = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee() {
        var _ref2,
            categories,
            isCommon,
            ignoreRuleTags,
            _args = arguments;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _ref2 = _args.length > 0 && _args[0] !== undefined ? _args[0] : {}, categories = _ref2.categories, isCommon = _ref2.isCommon, ignoreRuleTags = _ref2.ignoreRuleTags;
                _context.next = 3;
                return this._callApi({
                  method: 'get',
                  path: '/canned-messages',
                  queryParams: {
                    categories: categories,
                    isCommon: isCommon,
                    ignoreRuleTags: ignoreRuleTags
                  },
                  errorName: 'CannedMessagesError'
                });

              case 3:
                return _context.abrupt("return", _context.sent);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getCannedMessagesList() {
        return _getCannedMessagesList.apply(this, arguments);
      }

      return getCannedMessagesList;
    }()
    /**
     * @param {String} param0.messageId id of canned message
     * @returns {Object} canned message
     */

  }, {
    key: "getCannedMessage",
    value: function () {
      var _getCannedMessage = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2(_ref3) {
        var messageId;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                messageId = _ref3.messageId;
                _context2.next = 3;
                return this._callApi({
                  method: 'get',
                  path: '/canned-messages',
                  queryParams: {
                    messageId: messageId
                  },
                  errorName: 'CannedMessagesError'
                });

              case 3:
                return _context2.abrupt("return", _context2.sent);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getCannedMessage(_x) {
        return _getCannedMessage.apply(this, arguments);
      }

      return getCannedMessage;
    }()
    /**
     * @param {String} param0.text text of canned message
     * @param {Array} param1.category category of canned message
     * @param {Boolean} param2.isCommon is common canned message
     * @param {Array} param3.ruleTags tags that allow to get msg
     * @param {String} param4.label short description of canned message
     * @param {String} param5.fileKeys file name attached to message
     * @returns {Object} added canned message
     */

  }, {
    key: "addCannedMessage",
    value: function () {
      var _addCannedMessage = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee3(_ref4) {
        var text, category, isCommon, ruleTags, label, fileKeys;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                text = _ref4.text, category = _ref4.category, isCommon = _ref4.isCommon, ruleTags = _ref4.ruleTags, label = _ref4.label, fileKeys = _ref4.fileKeys;
                _context3.next = 3;
                return this._callApi({
                  method: 'post',
                  path: '/canned-messages',
                  payload: {
                    text: text,
                    category: category,
                    isCommon: isCommon,
                    ruleTags: ruleTags,
                    label: label,
                    fileKeys: fileKeys
                  },
                  errorName: 'CannedMessagesError'
                });

              case 3:
                return _context3.abrupt("return", _context3.sent);

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function addCannedMessage(_x2) {
        return _addCannedMessage.apply(this, arguments);
      }

      return addCannedMessage;
    }()
    /**
     * @param {String} param0.messageId id of canned message
     * @param {String} param1.text text of canned message
     * @param {String} param2.category category of canned message
     * @param {Array} param3.ruleTags tags that allow to get msg
     * @param {String} param4.label short description of canned message
     * @param {String} param5.fileKeys file name attached to message
     * @returns {Object} update stats
     */

  }, {
    key: "updateCannedMessage",
    value: function () {
      var _updateCannedMessage = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee4(_ref5) {
        var messageId, text, category, ruleTags, label, fileKeys;
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                messageId = _ref5.messageId, text = _ref5.text, category = _ref5.category, ruleTags = _ref5.ruleTags, label = _ref5.label, fileKeys = _ref5.fileKeys;
                _context4.next = 3;
                return this._callApi({
                  method: 'put',
                  path: '/canned-messages',
                  payload: {
                    messageId: messageId,
                    text: text,
                    category: category,
                    ruleTags: ruleTags,
                    label: label,
                    fileKeys: fileKeys
                  },
                  errorName: 'CannedMessagesError'
                });

              case 3:
                return _context4.abrupt("return", _context4.sent);

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function updateCannedMessage(_x3) {
        return _updateCannedMessage.apply(this, arguments);
      }

      return updateCannedMessage;
    }()
    /**
     * @param {String} param0.messageId id of canned message
     * @returns {Object} delete stats
     */

  }, {
    key: "deleteCannedMessage",
    value: function () {
      var _deleteCannedMessage = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee5(_ref6) {
        var messageId;
        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                messageId = _ref6.messageId;
                _context5.next = 3;
                return this._callApi({
                  method: 'delete',
                  path: '/canned-messages',
                  queryParams: {
                    messageId: messageId
                  },
                  errorName: 'CannedMessagesError'
                });

              case 3:
                return _context5.abrupt("return", _context5.sent);

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function deleteCannedMessage(_x4) {
        return _deleteCannedMessage.apply(this, arguments);
      }

      return deleteCannedMessage;
    }()
    /**
     *
     * @returns {Array} filters list
     */

  }, {
    key: "getFiltersList",
    value: function () {
      var _getFiltersList = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee6() {
        return _regenerator.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this._callApi({
                  method: 'get',
                  path: '/hitl/filters',
                  errorName: 'HitlFiltersError'
                });

              case 2:
                return _context6.abrupt("return", _context6.sent);

              case 3:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function getFiltersList() {
        return _getFiltersList.apply(this, arguments);
      }

      return getFiltersList;
    }()
    /**
     * @param {String} param0.filterId id of filter
     * @returns {Object} filter
     */

  }, {
    key: "getFilter",
    value: function () {
      var _getFilter = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee7(_ref7) {
        var filterId;
        return _regenerator.default.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                filterId = _ref7.filterId;
                _context7.next = 3;
                return this._callApi({
                  method: 'get',
                  path: '/hitl/filters',
                  queryParams: {
                    filterId: filterId
                  },
                  errorName: 'HitlFiltersError'
                });

              case 3:
                return _context7.abrupt("return", _context7.sent);

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function getFilter(_x5) {
        return _getFilter.apply(this, arguments);
      }

      return getFilter;
    }()
    /**
     * @param {String} param0.name name of filter
     * @param {Boolean} param1.isCommon common or personal filter
     * @param {Object} param2.settings filter settings
     * @param {Boolean} param3.isDefault default for apply common filter
     * @param {Number} param4.order order of filter
     * @returns {Object} added filter
     */

  }, {
    key: "addFilter",
    value: function () {
      var _addFilter = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee8(_ref8) {
        var name, isCommon, settings, isDefault, order;
        return _regenerator.default.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                name = _ref8.name, isCommon = _ref8.isCommon, settings = _ref8.settings, isDefault = _ref8.isDefault, order = _ref8.order;
                _context8.next = 3;
                return this._callApi({
                  method: 'post',
                  path: '/hitl/filters',
                  payload: {
                    name: name,
                    isCommon: isCommon,
                    settings: settings,
                    isDefault: isDefault,
                    order: order
                  },
                  errorName: 'HitlFiltersError'
                });

              case 3:
                return _context8.abrupt("return", _context8.sent);

              case 4:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function addFilter(_x6) {
        return _addFilter.apply(this, arguments);
      }

      return addFilter;
    }()
    /**
     * @param {String} param0.filterId id of filter
     * @param {String} param1.name name of filter
     * @param {Boolean} param2.isCommon common or personal filter
     * @param {Object} param3.settings filter settings
     * @param {Boolean} param4.isDefault default for apply common filter
     * @param {Number} param5.order order of filter
     * @returns {Object} update stats
     */

  }, {
    key: "updateFilter",
    value: function () {
      var _updateFilter = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee9(_ref9) {
        var filterId, name, isCommon, settings, isDefault, order;
        return _regenerator.default.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                filterId = _ref9.filterId, name = _ref9.name, isCommon = _ref9.isCommon, settings = _ref9.settings, isDefault = _ref9.isDefault, order = _ref9.order;
                _context9.next = 3;
                return this._callApi({
                  method: 'put',
                  path: '/hitl/filters',
                  payload: {
                    filterId: filterId,
                    name: name,
                    isCommon: isCommon,
                    settings: settings,
                    isDefault: isDefault,
                    order: order
                  },
                  errorName: 'HitlFiltersError'
                });

              case 3:
                return _context9.abrupt("return", _context9.sent);

              case 4:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function updateFilter(_x7) {
        return _updateFilter.apply(this, arguments);
      }

      return updateFilter;
    }()
    /**
     * @param {String} param0.filterId id of filter
     * @returns {Object} delete stats
     */

  }, {
    key: "deleteFilter",
    value: function () {
      var _deleteFilter = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee10(_ref10) {
        var filterId;
        return _regenerator.default.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                filterId = _ref10.filterId;
                _context10.next = 3;
                return this._callApi({
                  method: 'delete',
                  path: '/hitl/filters',
                  queryParams: {
                    filterId: filterId
                  },
                  errorName: 'HitlFiltersError'
                });

              case 3:
                return _context10.abrupt("return", _context10.sent);

              case 4:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function deleteFilter(_x8) {
        return _deleteFilter.apply(this, arguments);
      }

      return deleteFilter;
    }()
    /**
     *
     * @param {Object} param0.hitl_settings agents hitl settings
     * @returns {Object} agents hitl settings
     */

  }, {
    key: "createHitlSettings",
    value: function () {
      var _createHitlSettings = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee11(_ref11) {
        var hitl_settings;
        return _regenerator.default.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                hitl_settings = _ref11.hitl_settings;
                _context11.next = 3;
                return this._callApi({
                  method: 'post',
                  path: '/hitl/settings',
                  payload: hitl_settings,
                  errorName: 'HitlSettingsError'
                });

              case 3:
                return _context11.abrupt("return", _context11.sent);

              case 4:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function createHitlSettings(_x9) {
        return _createHitlSettings.apply(this, arguments);
      }

      return createHitlSettings;
    }()
    /**
     *
     * @returns {Object} agents settings (notifications, rwsAssistant)
     */

  }, {
    key: "getHitlSettings",
    value: function () {
      var _getHitlSettings = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee12(_ref12) {
        var isCommon, category;
        return _regenerator.default.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                isCommon = _ref12.isCommon, category = _ref12.category;
                _context12.next = 3;
                return this._callApi({
                  method: 'get',
                  path: '/hitl/settings',
                  queryParams: {
                    isCommon: isCommon,
                    category: category
                  },
                  errorName: 'HitlSettingsError'
                });

              case 3:
                return _context12.abrupt("return", _context12.sent);

              case 4:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function getHitlSettings(_x10) {
        return _getHitlSettings.apply(this, arguments);
      }

      return getHitlSettings;
    }()
    /**
     *
     * @returns {Object} UI layout setting
     */

  }, {
    key: "getUILayout",
    value: function () {
      var _getUILayout = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee13() {
        var res;
        return _regenerator.default.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.next = 2;
                return this.getHitlSettings({
                  isCommon: true,
                  category: 'UILayout'
                });

              case 2:
                res = _context13.sent;
                return _context13.abrupt("return", _lodash.default.get(res, 'layout') ? _lodash.default.get(res, 'layout') : res);

              case 4:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function getUILayout() {
        return _getUILayout.apply(this, arguments);
      }

      return getUILayout;
    }()
    /**
     *
     * @param {Object} param0.layout UI layout setting
     * @returns {Object} agents hitl settings
     */

  }, {
    key: "saveUILayout",
    value: function () {
      var _saveUILayout = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee14(_ref13) {
        var layout;
        return _regenerator.default.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                layout = _ref13.layout;
                _context14.next = 3;
                return this.createHitlSettings({
                  hitl_settings: {
                    category: 'UILayout',
                    isCommon: true,
                    locked: true,
                    layout: layout
                  }
                });

              case 3:
                return _context14.abrupt("return", _context14.sent);

              case 4:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function saveUILayout(_x11) {
        return _saveUILayout.apply(this, arguments);
      }

      return saveUILayout;
    }()
    /**
     *
     * @returns {Array} agents events templates list
     */

  }, {
    key: "getEventsTemplatesList",
    value: function () {
      var _getEventsTemplatesList = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee15() {
        return _regenerator.default.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.next = 2;
                return this._callApi({
                  method: 'get',
                  path: '/events-templates',
                  errorName: 'TemplatesError'
                });

              case 2:
                return _context15.abrupt("return", _context15.sent);

              case 3:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function getEventsTemplatesList() {
        return _getEventsTemplatesList.apply(this, arguments);
      }

      return getEventsTemplatesList;
    }()
    /**
     * @param {String} param0.templateId id of event template
     * @returns {Object} agents event template
     */

  }, {
    key: "getEventTemplate",
    value: function () {
      var _getEventTemplate = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee16(_ref14) {
        var templateId;
        return _regenerator.default.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                templateId = _ref14.templateId;
                _context16.next = 3;
                return this._callApi({
                  method: 'get',
                  path: '/events-templates',
                  queryParams: {
                    templateId: templateId
                  },
                  errorName: 'TemplatesError'
                });

              case 3:
                return _context16.abrupt("return", _context16.sent);

              case 4:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function getEventTemplate(_x12) {
        return _getEventTemplate.apply(this, arguments);
      }

      return getEventTemplate;
    }()
    /**
     * @param {String} param0.templateId id of event template
     * @param {String} param1.eventType type of event
     * @param {String} param2.rule rule in js
     * @param {String} param3.active is active rule for template
     * @param {Object} param4.template template with html, js, css, sass properties
     * @returns {Object} add stats
     */

  }, {
    key: "addEventTemplate",
    value: function () {
      var _addEventTemplate = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee17(_ref15) {
        var templateId, eventType, rule, active, visibility, template;
        return _regenerator.default.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                templateId = _ref15.templateId, eventType = _ref15.eventType, rule = _ref15.rule, active = _ref15.active, visibility = _ref15.visibility, template = _ref15.template;
                _context17.next = 3;
                return this._callApi({
                  method: 'post',
                  path: '/events-templates',
                  payload: {
                    templateId: templateId,
                    eventType: eventType,
                    rule: rule,
                    active: active,
                    visibility: visibility,
                    template: template
                  },
                  errorName: 'TemplatesError'
                });

              case 3:
                return _context17.abrupt("return", _context17.sent);

              case 4:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function addEventTemplate(_x13) {
        return _addEventTemplate.apply(this, arguments);
      }

      return addEventTemplate;
    }()
    /**
     * @param {String} param0.templateId id of event template
     * @param {String} param1.eventType type of event
     * @param {String} param2.rule rule in js
     * @param {String} param3.active is active rule for template
     * @param {Object} param4.template template with html, js, css, sass properties
     * @returns {Object} update stats
     */

  }, {
    key: "updateEventTemplate",
    value: function () {
      var _updateEventTemplate = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee18(_ref16) {
        var templateId, eventType, rule, active, visibility, template;
        return _regenerator.default.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                templateId = _ref16.templateId, eventType = _ref16.eventType, rule = _ref16.rule, active = _ref16.active, visibility = _ref16.visibility, template = _ref16.template;
                _context18.next = 3;
                return this._callApi({
                  method: 'put',
                  path: '/events-templates',
                  payload: {
                    templateId: templateId,
                    eventType: eventType,
                    rule: rule,
                    active: active,
                    visibility: visibility,
                    template: template
                  },
                  errorName: 'TemplatesError'
                });

              case 3:
                return _context18.abrupt("return", _context18.sent);

              case 4:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));

      function updateEventTemplate(_x14) {
        return _updateEventTemplate.apply(this, arguments);
      }

      return updateEventTemplate;
    }()
    /**
     * @param {String} param0.templateId id of event template
     * @returns {Object} delete stats
     */

  }, {
    key: "deleteEventTemplate",
    value: function () {
      var _deleteEventTemplate = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee19(_ref17) {
        var templateId;
        return _regenerator.default.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                templateId = _ref17.templateId;
                _context19.next = 3;
                return this._callApi({
                  method: 'delete',
                  path: '/events-templates',
                  queryParams: {
                    templateId: templateId
                  },
                  errorName: 'TemplatesError'
                });

              case 3:
                return _context19.abrupt("return", _context19.sent);

              case 4:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));

      function deleteEventTemplate(_x15) {
        return _deleteEventTemplate.apply(this, arguments);
      }

      return deleteEventTemplate;
    }()
    /**
     *
     * @param {String} param0.projection projection for get specified fields
     * @param {Number} param1.limit id of agent
     * @param {Object} param2.last last id
     * @returns {Array} of agents list
     */

  }, {
    key: "getAgentsList",
    value: function () {
      var _getAgentsList = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee20() {
        var _ref18,
            projection,
            chunked,
            limit,
            last,
            _args20 = arguments;

        return _regenerator.default.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                _ref18 = _args20.length > 0 && _args20[0] !== undefined ? _args20[0] : {}, projection = _ref18.projection, chunked = _ref18.chunked, limit = _ref18.limit, last = _ref18.last;
                _context20.next = 3;
                return this._callApi({
                  method: 'get',
                  path: '/hitl/agents',
                  queryParams: {
                    projection: projection,
                    chunked: chunked,
                    limit: limit,
                    last: last
                  },
                  errorName: 'AgentError'
                });

              case 3:
                return _context20.abrupt("return", _context20.sent);

              case 4:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, this);
      }));

      function getAgentsList() {
        return _getAgentsList.apply(this, arguments);
      }

      return getAgentsList;
    }()
    /**
     *
     * @param {String} param0.agentId id of agent
     * @param {String} param1.projection projection for get specified fields
     * @returns {Object} agent
     */

  }, {
    key: "getAgent",
    value: function () {
      var _getAgent = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee21(_ref19) {
        var agentId, projection;
        return _regenerator.default.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                agentId = _ref19.agentId, projection = _ref19.projection;
                _context21.next = 3;
                return this._callApi({
                  method: 'get',
                  path: '/hitl/agents',
                  queryParams: {
                    agentId: agentId,
                    projection: projection
                  },
                  errorName: 'AgentError'
                });

              case 3:
                return _context21.abrupt("return", _context21.sent);

              case 4:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, this);
      }));

      function getAgent(_x16) {
        return _getAgent.apply(this, arguments);
      }

      return getAgent;
    }()
    /**
     *
     * @param {Array} param0.agentIds ids of agent
     * @param {String} param1.projection projection for get specified fields
     * @param {Number} param2.limit id of agent
     * @param {Object} param3.last last id
     * @returns {Array} agents
     */

  }, {
    key: "getAgents",
    value: function () {
      var _getAgents = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee22(_ref20) {
        var agentIds, projection;
        return _regenerator.default.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                agentIds = _ref20.agentIds, projection = _ref20.projection;
                _context22.next = 3;
                return this._callApi({
                  method: 'get',
                  path: "/hitl/agents",
                  queryParams: {
                    agentIds: agentIds,
                    projection: projection
                  },
                  errorName: 'AgentError'
                });

              case 3:
                return _context22.abrupt("return", _context22.sent);

              case 4:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, this);
      }));

      function getAgents(_x17) {
        return _getAgents.apply(this, arguments);
      }

      return getAgents;
    }()
    /**
     *
     * @param {String} param0.agentId id of agent
     * @param {Array} param0.rulesGroups groups of rules for agent
     */

  }, {
    key: "updateAgentRulesGroups",
    value: function () {
      var _updateAgentRulesGroups = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee23(_ref21) {
        var agentId, rulesGroups;
        return _regenerator.default.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                agentId = _ref21.agentId, rulesGroups = _ref21.rulesGroups;
                _context23.next = 3;
                return this._callApi({
                  method: 'put',
                  path: '/hitl/agents',
                  queryParams: {
                    agentId: agentId
                  },
                  payload: {
                    rulesGroups: rulesGroups
                  },
                  errorName: 'AgentError'
                });

              case 3:
                return _context23.abrupt("return", _context23.sent);

              case 4:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, this);
      }));

      function updateAgentRulesGroups(_x18) {
        return _updateAgentRulesGroups.apply(this, arguments);
      }

      return updateAgentRulesGroups;
    }()
    /**
     * 
     * @returns {Object} agent's (self) current status, if exists, last actively set status or default status otherwise
     */

  }, {
    key: "getInitialAgentStatus",
    value: function () {
      var _getInitialAgentStatus = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee24() {
        return _regenerator.default.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                _context24.next = 2;
                return this._callApi({
                  method: 'get',
                  path: '/hitl/agents/actual-status',
                  errorName: 'AgentError'
                });

              case 2:
                return _context24.abrupt("return", _context24.sent);

              case 3:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24, this);
      }));

      function getInitialAgentStatus() {
        return _getInitialAgentStatus.apply(this, arguments);
      }

      return getInitialAgentStatus;
    }()
    /**
     *
     * @param {String} param0.agentId id of agent
     * @param {String} param1.status agent status - Online, Busy, Offline
     * @param {String} param2.lastStatusUpdate date in ISO string format last update of status
     * @param {String} param3.busyReason reason of BUSY
     * @param {String} param4.v api version
     */

  }, {
    key: "updateAgentStatus",
    value: function () {
      var _updateAgentStatus = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee25(_ref22) {
        var agentId, status, lastStatusUpdate, busyReason, v;
        return _regenerator.default.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                agentId = _ref22.agentId, status = _ref22.status, lastStatusUpdate = _ref22.lastStatusUpdate, busyReason = _ref22.busyReason, v = _ref22.v;
                _context25.next = 3;
                return this._callApi({
                  method: 'put',
                  path: '/hitl/agents/status',
                  queryParams: {
                    agentId: agentId
                  },
                  payload: {
                    statusData: {
                      status: status,
                      lastStatusUpdate: lastStatusUpdate,
                      busyReason: busyReason
                    },
                    v: v
                  },
                  errorName: 'AgentError'
                });

              case 3:
                return _context25.abrupt("return", _context25.sent);

              case 4:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25, this);
      }));

      function updateAgentStatus(_x19) {
        return _updateAgentStatus.apply(this, arguments);
      }

      return updateAgentStatus;
    }()
    /**
     * @param {String} param0.agentId agentId
     * @param {Array} param1.addRulesGroups array of groups ids add to agent groups
     * @param {Array} param2.removeRulesGroups array of groups ids remove to agent groups
     * @returns {Object} agent groups
     */

  }, {
    key: "patchAgentRulesGroup",
    value: function () {
      var _patchAgentRulesGroup = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee26(_ref23) {
        var agentId, addRulesGroups, removeRulesGroups;
        return _regenerator.default.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                agentId = _ref23.agentId, addRulesGroups = _ref23.addRulesGroups, removeRulesGroups = _ref23.removeRulesGroups;
                _context26.next = 3;
                return this._callApi({
                  method: 'patch',
                  path: '/hitl/agents',
                  queryParams: {
                    agentId: agentId
                  },
                  payload: {
                    addRulesGroups: addRulesGroups,
                    removeRulesGroups: removeRulesGroups
                  },
                  errorName: 'RulesGroupsError'
                });

              case 3:
                return _context26.abrupt("return", _context26.sent);

              case 4:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26, this);
      }));

      function patchAgentRulesGroup(_x20) {
        return _patchAgentRulesGroup.apply(this, arguments);
      }

      return patchAgentRulesGroup;
    }()
    /**
     *
     * @returns {Array} rules groups list
     */

  }, {
    key: "getRulesGroupsList",
    value: function () {
      var _getRulesGroupsList = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee27() {
        return _regenerator.default.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                _context27.next = 2;
                return this._callApi({
                  method: 'get',
                  path: '/rules-groups',
                  errorName: 'RulesGroupsError'
                });

              case 2:
                return _context27.abrupt("return", _context27.sent);

              case 3:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27, this);
      }));

      function getRulesGroupsList() {
        return _getRulesGroupsList.apply(this, arguments);
      }

      return getRulesGroupsList;
    }()
    /**
     * @param {String} param0.groupId id of rules group
     * @returns {Object} (object | array) rules group or rules groups
     */

  }, {
    key: "getRulesGroup",
    value: function () {
      var _getRulesGroup = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee28(_ref24) {
        var groupId;
        return _regenerator.default.wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                groupId = _ref24.groupId;
                _context28.next = 3;
                return this._callApi({
                  method: 'get',
                  path: '/rules-groups',
                  queryParams: {
                    groupId: groupId
                  },
                  errorName: 'RulesGroupsError'
                });

              case 3:
                return _context28.abrupt("return", _context28.sent);

              case 4:
              case "end":
                return _context28.stop();
            }
          }
        }, _callee28, this);
      }));

      function getRulesGroup(_x21) {
        return _getRulesGroup.apply(this, arguments);
      }

      return getRulesGroup;
    }()
    /**
     * @param {Array} param0.groupIds ids of rules group
     * @returns {Object} (object | array) rules group or rules groups
     */

  }, {
    key: "getRuleGroups",
    value: function () {
      var _getRuleGroups = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee29(_ref25) {
        var groupIds;
        return _regenerator.default.wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                groupIds = _ref25.groupIds;
                _context29.next = 3;
                return this._callApi({
                  method: 'get',
                  path: '/rules-groups',
                  queryParams: {
                    groupIds: groupIds
                  },
                  errorName: 'RulesGroupsError'
                });

              case 3:
                return _context29.abrupt("return", _context29.sent);

              case 4:
              case "end":
                return _context29.stop();
            }
          }
        }, _callee29, this);
      }));

      function getRuleGroups(_x22) {
        return _getRuleGroups.apply(this, arguments);
      }

      return getRuleGroups;
    }()
    /**
     * @param {String} param0.name name of rules group
     * @param {Array} param1.rules agent permissions rules
     * @returns {Object} add stats
     */

  }, {
    key: "addRulesGroup",
    value: function () {
      var _addRulesGroup = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee30(_ref26) {
        var name, rules;
        return _regenerator.default.wrap(function _callee30$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                name = _ref26.name, rules = _ref26.rules;
                _context30.next = 3;
                return this._callApi({
                  method: 'post',
                  path: '/rules-groups',
                  payload: {
                    name: name,
                    rules: rules
                  },
                  errorName: 'RulesGroupsError'
                });

              case 3:
                return _context30.abrupt("return", _context30.sent);

              case 4:
              case "end":
                return _context30.stop();
            }
          }
        }, _callee30, this);
      }));

      function addRulesGroup(_x23) {
        return _addRulesGroup.apply(this, arguments);
      }

      return addRulesGroup;
    }()
    /**
     * @param {String} param0.groupId id of rules group
     * @param {String} param1.name name of rules group
     * @param {Array} param2.rules agent permissions rules
     * @returns {Object} update stats
     */

  }, {
    key: "updateRulesGroup",
    value: function () {
      var _updateRulesGroup = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee31(_ref27) {
        var groupId, name, rules;
        return _regenerator.default.wrap(function _callee31$(_context31) {
          while (1) {
            switch (_context31.prev = _context31.next) {
              case 0:
                groupId = _ref27.groupId, name = _ref27.name, rules = _ref27.rules;
                _context31.next = 3;
                return this._callApi({
                  method: 'put',
                  path: '/rules-groups',
                  payload: {
                    groupId: groupId,
                    name: name,
                    rules: rules
                  },
                  errorName: 'RulesGroupsError'
                });

              case 3:
                return _context31.abrupt("return", _context31.sent);

              case 4:
              case "end":
                return _context31.stop();
            }
          }
        }, _callee31, this);
      }));

      function updateRulesGroup(_x24) {
        return _updateRulesGroup.apply(this, arguments);
      }

      return updateRulesGroup;
    }()
    /**
     * @param {String} param0.groupId id of rules group
     * @returns {Object} delete stats
     */

  }, {
    key: "deleteRulesGroup",
    value: function () {
      var _deleteRulesGroup = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee32(_ref28) {
        var groupId;
        return _regenerator.default.wrap(function _callee32$(_context32) {
          while (1) {
            switch (_context32.prev = _context32.next) {
              case 0:
                groupId = _ref28.groupId;
                _context32.next = 3;
                return this._callApi({
                  method: 'delete',
                  path: '/rules-groups',
                  queryParams: {
                    groupId: groupId
                  },
                  errorName: 'RulesGroupsError'
                });

              case 3:
                return _context32.abrupt("return", _context32.sent);

              case 4:
              case "end":
                return _context32.stop();
            }
          }
        }, _callee32, this);
      }));

      function deleteRulesGroup(_x25) {
        return _deleteRulesGroup.apply(this, arguments);
      }

      return deleteRulesGroup;
    }()
    /**
     *
     * @param {Array} param0.groupIds ids of agent rules groups
     * @param {String} param1.status status of agents
     * @returns {Array} agents
     */

  }, {
    key: "searchAgents",
    value: function () {
      var _searchAgents = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee33(_ref29) {
        var rulesGroupsIds, status, ruleTags, excludeRequestAgent;
        return _regenerator.default.wrap(function _callee33$(_context33) {
          while (1) {
            switch (_context33.prev = _context33.next) {
              case 0:
                rulesGroupsIds = _ref29.rulesGroupsIds, status = _ref29.status, ruleTags = _ref29.ruleTags, excludeRequestAgent = _ref29.excludeRequestAgent;
                _context33.next = 3;
                return this._callApi({
                  method: 'get',
                  path: "/agents/search",
                  queryParams: {
                    rulesGroupsIds: rulesGroupsIds,
                    status: status,
                    ruleTags: ruleTags,
                    excludeRequestAgent: excludeRequestAgent
                  },
                  errorName: 'AgentError'
                });

              case 3:
                return _context33.abrupt("return", _context33.sent);

              case 4:
              case "end":
                return _context33.stop();
            }
          }
        }, _callee33, this);
      }));

      function searchAgents(_x26) {
        return _searchAgents.apply(this, arguments);
      }

      return searchAgents;
    }()
    /**
     * @param {String} param0.name part of name to search groups
     * @param {Array} param0.rules list of rules to search groups
     * @returns {Array} rules groups
     */

  }, {
    key: "searchRulesGroup",
    value: function () {
      var _searchRulesGroup = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee34(_ref30) {
        var name, rules;
        return _regenerator.default.wrap(function _callee34$(_context34) {
          while (1) {
            switch (_context34.prev = _context34.next) {
              case 0:
                name = _ref30.name, rules = _ref30.rules;
                _context34.next = 3;
                return this._callApi({
                  method: 'post',
                  path: '/rules-groups/search',
                  queryParams: {
                    name: name,
                    rules: rules
                  },
                  errorName: 'RulesGroupsError'
                });

              case 3:
                return _context34.abrupt("return", _context34.sent);

              case 4:
              case "end":
                return _context34.stop();
            }
          }
        }, _callee34, this);
      }));

      function searchRulesGroup(_x27) {
        return _searchRulesGroup.apply(this, arguments);
      }

      return searchRulesGroup;
    }()
    /**
     * @param {String} param0.index name of table
     * @returns {Object} index structure
     */

  }, {
    key: "getTableStructure",
    value: function () {
      var _getTableStructure = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee35(_ref31) {
        var index;
        return _regenerator.default.wrap(function _callee35$(_context35) {
          while (1) {
            switch (_context35.prev = _context35.next) {
              case 0:
                index = _ref31.index;
                _context35.next = 3;
                return this._callApi({
                  method: 'get',
                  path: '/mappings',
                  queryParams: {
                    index: index
                  },
                  errorName: 'MappingsError'
                });

              case 3:
                return _context35.abrupt("return", _context35.sent);

              case 4:
              case "end":
                return _context35.stop();
            }
          }
        }, _callee35, this);
      }));

      function getTableStructure(_x28) {
        return _getTableStructure.apply(this, arguments);
      }

      return getTableStructure;
    }()
    /**
     * @param {String} param0.index name of table
     * @param {Object} param1.mappings raw mappings to create
     * @param {String} param2.property name of column
     * @param {Boolean} param3.typeOf type of column - 'string', 'object', 'array of strings' or 'array of objects'
     * @param {Object} param4.properties properties of 'objects' and 'array of objects' types
     * @param {Boolean} param5.visibility display on UI
     * @param {Number} param6.order order of property
     * @param {String} param7.label label on UI
     * @returns {Object} empty
     */

  }, {
    key: "addTableColumn",
    value: function () {
      var _addTableColumn = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee36(_ref32) {
        var index, mappings, property, typeOf, properties, visibility, order, label;
        return _regenerator.default.wrap(function _callee36$(_context36) {
          while (1) {
            switch (_context36.prev = _context36.next) {
              case 0:
                index = _ref32.index, mappings = _ref32.mappings, property = _ref32.property, typeOf = _ref32.typeOf, properties = _ref32.properties, visibility = _ref32.visibility, order = _ref32.order, label = _ref32.label;
                _context36.next = 3;
                return this._callApi({
                  method: 'post',
                  path: '/mappings',
                  payload: {
                    index: index,
                    mappings: mappings,
                    property: property,
                    typeOf: typeOf,
                    properties: properties,
                    visibility: visibility,
                    order: order,
                    label: label
                  },
                  errorName: 'MappingsError'
                });

              case 3:
                return _context36.abrupt("return", _context36.sent);

              case 4:
              case "end":
                return _context36.stop();
            }
          }
        }, _callee36, this);
      }));

      function addTableColumn(_x29) {
        return _addTableColumn.apply(this, arguments);
      }

      return addTableColumn;
    }()
  }]);
  return HitlSettingsApi;
}(_basic_provider.default);

var _default = HitlSettingsApi;
exports.default = _default;